import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  Columns,
  Block,
  Content,
  StyledImage,
  Footer,
} from './styles';

// * sectionTiles {obj} richtext obj provided by primsic
// * items {array} array of data from prismic for each card. Contains a heading {string}, image src {string}, bodyCopy {string}

const EpisodeSection = ({ sectionId, data }) => {
  if (!data) return null;
  const {
    sectionTitleHtml,
    sectionSubtitleHTML,
    columnAlignment,
    items,
    titleHtml,
    buttonLink,
    buttonText,
    buttonType,
    ariaLabelButton,
    queryStringButton,
    colourOverrideBackground,
    focusTextColour,
    backgroundImage,
  } = data;

  return (
    <Wrapper
      colourOverrideBackground={colourOverrideBackground}
      background={backgroundImage ? backgroundImage.url : null}
    >
      <StyledContainer
        id={sectionId}
        className="auto-margin episode-section"
        focusTextColour={focusTextColour}
      >
        {ReactHtmlParser(sectionTitleHtml)}
        {ReactHtmlParser(sectionSubtitleHTML)}
        <Columns className="regular-columns episode-columns" columns={3}>
          {items.map(
            (
              {
                itemImage,
                imageItemSharp,
                itemHeadingHtml,
                itemSubHeadingHtml,
                itemBodyCopyHtml,
                cta,
                ctaText,
              },
              index
            ) => {
              return (
                <Block
                  className={columnAlignment}
                  key={`values-${columnAlignment}-${index.toString()}`}
                >
                  {cta && (
                    <Link to={`${cta.url}/`} className="episodelink">
                      {imageItemSharp && (
                        <StyledImage
                          src={imageItemSharp}
                          alt={itemImage.altTag}
                          className="episode-image"
                        />
                      )}
                      <Content>
                        {ReactHtmlParser(itemHeadingHtml)}
                        {ReactHtmlParser(itemSubHeadingHtml)}
                        {ReactHtmlParser(itemBodyCopyHtml)}
                      </Content>
                    </Link>
                  )}
                  {ctaText && (
                    <Footer>
                      {ReactHtmlParser(titleHtml)}
                      {cta && ctaText && (
                        <Link
                          to={`${cta.url}/`}
                          className={`episode-cta ${buttonType}`}
                          ariaLabel={ariaLabelButton}
                          queryString={queryStringButton}
                        >
                          {ctaText}
                        </Link>
                      )}
                    </Footer>
                  )}
                </Block>
              );
            }
          )}
        </Columns>
        {(titleHtml || buttonText) && (
          <Footer>
            {ReactHtmlParser(titleHtml)}
            {buttonLink && buttonText && (
              <Link
                to={`${buttonLink.url}/`}
                className={buttonType}
                ariaLabel={ariaLabelButton}
                queryString={queryStringButton}
              >
                {buttonText}
              </Link>
            )}
          </Footer>
        )}
      </StyledContainer>
    </Wrapper>
  );
};
EpisodeSection.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
};

export default EpisodeSection;
